import { api } from './client';
import type {
  CreateSessionRequest,
  Session,
  StartSessionRequest,
} from '@/types';

export function listSessions(limit = 50, agentId?: string): Promise<Session[]> {
  const q = new URLSearchParams({ limit: String(limit) });
  if (agentId) q.set('agent_id', agentId);
  return api<Session[]>(`/api/sessions?${q.toString()}`);
}

export function getSession(id: string): Promise<Session> {
  return api<Session>(`/api/sessions/${id}`);
}

export function createSession(req: CreateSessionRequest): Promise<Session> {
  return api<Session>('/api/sessions', { method: 'POST', body: req });
}

export function startSession(
  id: string,
  req: StartSessionRequest,
): Promise<Session> {
  return api<Session>(`/api/sessions/${id}/start`, { method: 'POST', body: req });
}

export function stopSession(id: string): Promise<Session> {
  return api<Session>(`/api/sessions/${id}/stop`, { method: 'POST' });
}

export function deleteSession(id: string): Promise<void> {
  return api<void>(`/api/sessions/${id}`, { method: 'DELETE' });
}
